import { useState, useEffect } from 'react';
import { axiosReq } from '../api/axiosDefaults';

const useFetchOwners = (enabled = true) => {
    const [owners, setOwners] = useState([]);
    const [hasLoaded, setHasLoaded] = useState(!enabled);

    useEffect(() => {
        if (!enabled) {
            setHasLoaded(true);
            return;
        }

        let isMounted = true;
        const abortController = new AbortController();

        const fetchOwners = async () => {
            try {
                setHasLoaded(false);
                let allOwners = [];
                let nextUrl = '/listings/owners/?page_size=100';
                let pageCount = 0;
                const maxPages = 20;

                while (nextUrl && pageCount < maxPages) {
                    const { data } = await axiosReq.get(nextUrl, {
                        signal: abortController.signal,
                    });

                    if (!isMounted) break;

                    if (data.results && Array.isArray(data.results)) {
                        allOwners = [...allOwners, ...data.results];
                    } else if (Array.isArray(data)) {
                        allOwners = [...allOwners, ...data];
                        break;
                    }

                    nextUrl = data.next;

                    if (nextUrl && (nextUrl.startsWith('http://') || nextUrl.startsWith('https://'))) {
                        const url = new URL(nextUrl);
                        const baseURL = axiosReq.defaults?.baseURL || '';
                        nextUrl = baseURL && url.pathname.startsWith(baseURL)
                            ? url.pathname.substring(baseURL.length) + url.search
                            : url.pathname + url.search;
                    }

                    pageCount++;
                }

                if (isMounted) {
                    setOwners(allOwners);
                    setHasLoaded(true);
                }
            } catch (err) {
                if (isMounted && err.name !== 'AbortError' && err.name !== 'CanceledError') {
                    console.error('Error fetching owners:', err);
                    setHasLoaded(true);
                }
            }
        };

        fetchOwners();

        return () => {
            isMounted = false;
            abortController.abort();
        };
    }, [enabled]);

    return { owners, setOwners, hasLoaded };
};

export default useFetchOwners;